/* eslint-disable prefer-destructuring */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/prefer-default-export */

import { Chip, CircularProgress, Icon } from "@mui/material";
import { Tooltip } from "chart.js";
import MDBox from "components/Basics/MDBox";
import i18n from "i18n";
import lod_ from "lodash";

const ColorItemLabel = ({ color }) => {
	return (
		<div
			style={{
				height: "3vh",
				width: "3vh",
				borderRadius: "7px",
				backgroundColor: color
			}}
		></div>
	);
};

const createObjectTable = (obj, cell, dictionary, form) => {
	let collection = form?.collectionDefault;
	let attribute = cell?.column?.id;

	if (!collection || !attribute) return null;

	let midPath = collection + "." + attribute;

	let sample = obj[0];
	let sampleKeys = Object.keys(sample);

	return (
		<table>
			<thead>
				<tr>
					{sampleKeys.map((key, index) => {
						let realPath = midPath + "." + key;
						realPath = realPath.split(".")?.join(".items.");
						let fromDictionary = lod_.get(dictionary, realPath);
						if (fromDictionary) {
							return <th key={index}>{fromDictionary.label.fr}</th>;
						} else {
							return null;
						}
					})}
				</tr>
			</thead>
			<tbody>
				{obj.map((row, index) => {
					return (
						<tr key={index}>
							{sampleKeys.map((key, index) => {
								return <td key={index}>{row[key]}</td>;
							})}
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

const createArrayTable = arr => {
	return <div>{arr.join(", ")}</div>;
};

/**
 * ##############################
 * Display special fields in table
 * e.g : colors, icons, images, etc
 * ##############################
 */
export function handleSpecialCell(
	cell,
	rowKey,
	dictionary,
	form,
	chart = {},
	displayDictionaryName = null,
	extra
) {
	let dictionaryPath =
		(!lod_.isEmpty(displayDictionaryName) ? displayDictionaryName : chart?.request?.collection) +
		"." +
		cell.column.id;

	dictionaryPath = dictionaryPath.replaceAll(".", ".items.");
	let dictionaryItem = lod_.get(dictionary, dictionaryPath);

	const TYPE_DATE = ["date", "datetime"];
	const TYPE_DURATION = ["timestamp"];
	const TYPE_IMAGES = ["imageList", "uploadedImage"];

	let filtersLabel = [];

	switch (cell.column.id) {
		case "filters":
			cell.value.map((filter, index) => {
				let realPath = filter.dictionaryPath?.split(".")?.join(".items.");
				let fromDictionary = lod_.get(dictionary, realPath);
				if (fromDictionary && fromDictionary.analytics && fromDictionary.active) {
					filtersLabel.push(fromDictionary.label.fr);
				}
			});
			return <div>{filtersLabel.join(" / ")}</div>;
		case "skill": {
			// skill is an array of object, we will only display the name of the skill
			// we should display it as an array
			let skillNames = [];
			// do not loop through the cell value if it is undefined (a new profile without skills for exemple)
			if (lod_.isNil(cell.value)) return <div></div>;
			cell.value.forEach(skill => {
				skillNames.push(skill.name);
			});
			// order skillNames by alphabetical order
			skillNames.sort();
			// return createObjectTable(skillNames, cell, dictionary, form);
			return <div>{skillNames.join(", ")}</div>;
		}
		case "labels":
			return (
				<MDBox>
					{!lod_.isEmpty(cell.value) ? (
						<>
							{Object.keys(cell.value).map((childItem, key) => {
								return (
									<div style={{ display: "flex" }}>
										<span style={{ fontWeight: "bolder" }}>{childItem} </span>
										<span>{" : " + cell.value[childItem]}</span>
									</div>
								);
							})}
						</>
					) : (
						<MDBox></MDBox>
					)}
				</MDBox>
			);

		case "color":
			return <ColorItemLabel color={cell.value} />;
		case "display.pages":
			return <div>{cell.value.join(", ")}</div>;
		case "images":
			if (!cell.value) return null;
			return <div>voir (bientot dispo)</div>;
		case "active":
		case "analysed":
		case "configured":
			if (!cell.value) {
				return (
					<Icon color="error" fontSize="medium">
						close
					</Icon>
				);
			} else {
				return (
					<Icon color="success" fontSize="medium">
						check
					</Icon>
				);
			}
		case "logoURL": {
			const url = cell.value;
			return (
				<MDBox
					component="img"
					src={url}
					alt={url}
					style={{
						width: "30px",
						height: "30px",
						// borderRadius: "50%",
						objectFit: "contain"
					}}
				/>
			);
		}
		default:
			/**
			 * Collection
			 */
			switch (chart?.request?.collection) {
				case "channel": {
					const values = cell.row.original ?? {};
					let possibleMessage = values.statusMessage;
					let message = null;

					const openEditDialogOnStep = extra?.openEditDialogOnStep ?? (() => {});

					if (possibleMessage) {
						if (i18n.exists(`CHANNEL.ERRORS.${possibleMessage}`)) {
							message = i18n.t(`CHANNEL.ERRORS.${possibleMessage}`);
						} else {
							message = possibleMessage;
						}
					}

					switch (cell.column.id) {
						case "status": {
							switch (cell.value) {
								case "testing":
									return (
										<Chip
											label={i18n.t("CHANNEL.STATUS.testing")}
											size="small"
											color="info"
											variant="outlined"
											icon={
												<CircularProgress
													size={17}
													sx={{
														padding: "1px",
														color: "info.focus"
													}}
												/>
											}
										/>
									);
								case "error":
								case "errored":
									return (
										<Tooltip placement="top" title={message}>
											<Chip
												label={i18n.t("CHANNEL.STATUS.badConfiguration")}
												size="small"
												color="error"
												variant="outlined"
												onClick={() => openEditDialogOnStep(values.code, "CONFIG_PART")}
												icon={<Icon fontSize="medium">cancel</Icon>}
											/>
										</Tooltip>
									);
								/**
								 * Operational case, check if we have other errors
								 */
								case "operational": {
									const original = cell.row.original;
									// Token
									const tokenInfos = original?.tokenStatus;

									const status = tokenInfos?.status;
									const expirationTS = tokenInfos?.expiration;
									const expirationDays = Math.floor(expirationTS / (1000 * 60 * 60 * 24));
									switch (status) {
										case "warning":
											return (
												<Tooltip
													placement="top"
													title={i18n.t("CHANNEL.STATUS.TOKEN.warnRenewTokenAlert")}
												>
													<Chip
														label={i18n.t("CHANNEL.STATUS.TOKEN.expirationInLabel", {
															days: expirationDays
														})}
														size="small"
														color="warning"
														variant="outlined"
														onClick={() => openEditDialogOnStep(values.code, "CONFIG_PART")}
														icon={<Icon fontSize="medium">warning</Icon>}
													/>
												</Tooltip>
											);
										case "error":
											return (
												<Tooltip
													placement="top"
													title={i18n.t("CHANNEL.STATUS.TOKEN.errorRenewTokenAlert")}
												>
													<Chip
														label={i18n.t("CHANNEL.STATUS.TOKEN.expirationInLabel", {
															days: expirationDays
														})}
														size="small"
														color="error"
														variant="outlined"
														onClick={() => openEditDialogOnStep(values.code, "CONFIG_PART")}
														icon={<Icon fontSize="medium">error</Icon>}
													/>
												</Tooltip>
											);
										case "expired":
											return (
												<Tooltip
													placement="top"
													title={i18n.t("CHANNEL.STATUS.TOKEN.errorRenewTokenAlert")}
												>
													<Chip
														label={i18n.t("CHANNEL.STATUS.TOKEN.expired")}
														size="small"
														color="error"
														variant="outlined"
														onClick={() => openEditDialogOnStep(values.code, "CONFIG_PART")}
														icon={<Icon fontSize="medium">dangerous</Icon>}
													/>
												</Tooltip>
											);
										default:
											break;
									}

									/**
									 * Default: Everything is fine
									 */
									return (
										<Chip
											label={i18n.t("CHANNEL.STATUS.good")}
											size="small"
											color="success"
											variant="outlined"
											icon={<Icon fontSize="medium">done</Icon>}
										/>
									);
								}
								default: {
									const testChannelConfig = extra?.testChannelConfig ?? (() => {});
									return (
										<Chip
											label={i18n.t("CHANNEL.STATUS.checkConfiguration")}
											size="small"
											color="info"
											variant="filled"
											onClick={() => testChannelConfig(values)}
											icon={<Icon fontSize="medium">sync</Icon>}
										/>
									);
								}
							}
						}
						default:
							break;
					}
					break;
				}
				case "answerItem": {
					switch (cell.column.id) {
						case "channelsCode": {
							let channels = [
								{
									code: "ALL",
									name: i18n.t("COMPONENT.ANSWERTYPE.allChannels"),
									description: i18n.t("COMPONENT.ANSWERTYPE.allChannels"),
									icon: "message"
								},
								...(extra?.channels || [])
							];
							if (!channels) {
								break;
							}

							let mappedChannels = [];

							(cell.value || []).map(channelCode => {
								let channel = channels.find(channel => channel.code === channelCode);
								if (channel) {
									mappedChannels.push(channel);
								}
							});

							return (
								<MDBox display="flex" alignItems="center" flexDirection="row">
									{mappedChannels.map((channel, index) => {
										return (
											<Tooltip title={channel.name} placement="top" key={index}>
												<MDBox display="flex" alignItems="center" m={1}>
													{channel.logoURL && (
														<MDBox
															component="img"
															src={channel.logoURL}
															alt={channel.name}
															style={{
																width: "30px",
																height: "30px",
																// borderRadius: "50%",
																objectFit: "contain"
															}}
														/>
													)}
													{channel.icon && (
														<Icon
															fontSize="medium"
															sx={{
																width: "30px",
																height: "30px"
															}}
														>
															{channel.icon}
														</Icon>
													)}
												</MDBox>
											</Tooltip>
										);
									})}
								</MDBox>
							);
						}
						case "publishDate": {
							if (cell.value) {
								const date = new Date(cell.value);
								const formattedDate = date
									.toLocaleString("fr-FR", {
										year: "numeric",
										month: "2-digit",
										day: "2-digit",
										hour: "2-digit",
										minute: "2-digit",
										hour12: false
									})
									.replace(",", "");
								return <span>{formattedDate}</span>;
							}
							return <span>-</span>;
						}
						case "categories":
							if (!cell.value) return null;
							return (
								<MDBox sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
									{cell.value.map((category, index) => (
										<Chip
											key={index}
											label={typeof category === "string" ? category : category.name}
											sx={{
												backgroundColor: typeof category === "string" ? "#e0e0e0" : category.color,
												color: typeof category === "string" ? "#000" : "#fff",
												borderRadius: "4px",
												fontSize: "0.75rem"
											}}
										/>
									))}
								</MDBox>
							);
						default:
							break;
					}
					break;
				}
				case "messageStat": {
					switch (cell.column.id) {
						case "topicHasBeenUpdated": {
							const topicHasBeenUpdated = cell.row?.original?.topicHasBeenUpdated ?? false;
							if (topicHasBeenUpdated) {
								return (
									<Tooltip placement="top" title={i18n.t("INTENTS.intentUpdatedWithFeedback")}>
										<Icon fontSize="medium">rate_review</Icon>
									</Tooltip>
								);
							} else {
								return null;
							}
						}
						default:
							break;
					}
					break;
				}
				default:
					break;
			}

			/**
			 * Dictionary case handling
			 */
			if (dictionaryItem && TYPE_DATE.includes(dictionaryItem.type)) {
				return <span>{new Date(cell.value).toLocaleString("FR-fr")}</span>;
			}
			if (!lod_.isNil(cell?.value) && typeof cell.value === "boolean") {
				if (!cell.value) {
					return (
						<Icon color="error" fontSize="medium">
							close
						</Icon>
					);
				} else {
					return (
						<Icon color="success" fontSize="medium">
							check
						</Icon>
					);
				}
			}

			if (dictionaryItem && TYPE_IMAGES.includes(dictionaryItem.type)) {
				const imageSrc = cell.value?.url ?? cell.value;
				return (
					<MDBox
						component="img"
						src={imageSrc}
						onClick={() => {
							if (!imageSrc || !window?.navigator?.clipboard?.writeText) return;
							window.navigator.clipboard.writeText(imageSrc).catch(() => {});
						}}
						title={i18n.t("SETTINGS.DICTIONARY.copyToClipboard")}
						style={{
							height: "2rem",
							width: "2rem",
							objectFit: "contain"
						}}
					/>
				);
			}

			/**
			 * Default case handling
			 */
			if (cell.column.id === "examples" || cell.column.id === "predictions") {
				if (lod_.isArray(cell.value)) {
					return cell.value.length;
				} else if (lod_.isNil(cell.value)) {
					return "0";
				}
			}

			if (lod_.isArray(cell.value)) {
				let sample = cell.value[0];

				if (lod_.isObject(sample)) {
					return createObjectTable(cell.value, cell, dictionary, form);
				} else {
					return createArrayTable(cell.value);
				}
			} else if (lod_.isObject(cell.value)) {
				return createObjectTable(cell.value, cell, dictionary, form);
			} else {
				return cell.render("Cell");
			}
	}
}
